import styled from "styled-components";
import mondrian from 'core/config/theme';

const StyledTimer = styled.div`
  font-size: ${mondrian.fontSizeXxxs};
  font-family: ${mondrian.fontFamilyBase};
  font-weight: ${mondrian.fontWeightBold};
  margin-bottom: ${mondrian.spacingStackXs};
`;

export default StyledTimer;
